import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
  Typography,
  Box,
  useTheme,
  Chip,
  Divider,
  IconButton,
  Button,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import useStyles from "./styles";
import GrupoChip from "../../grupoEconomico/GrupoChip";
import dayjs from "dayjs";
import { useState } from "react";
import {
  VisibilityOff,
  Visibility,
  AddOutlined,
  Refresh,
} from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import api from "../../../services/api";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import { BusinessOutlined } from "@mui/icons-material";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import RouterOutlinedIcon from "@mui/icons-material/RouterOutlined";
import CastConnectedOutlinedIcon from "@mui/icons-material/CastConnectedOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ModalNewTicket from "../../tickets/modalNewTicket";
import ModalConexaoDetails from "./modalConexaoDetails";

export default function AccordionHubsoft(params) {
  const {
    id,
    nome,
    ownerNome,
    status,
    referencia,
    valor,
    enderecoInstalacao,
    dataHabilitacao,
    dataCasdastro,
    tecnologiaUsada,
    login,
    senha,
    equipamentoRoteamento,
    equipamentoRoteamentoIp,
    interfaceTipo,
    interfaceNome,
    portaAtendimento,
    dataInicioContrato,
    dataFimContrato,
    vigenciaMeses,
    grupos,
    setSnackbar,
    formaCobranca,
    tipoPagamento,
    tipoCobranca,
    dataVencimento,
    clienteInfo,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);
  const [openNewTicket, setOpenNewTicket] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [details, setDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [openConexaoDetails, setOpenConexaoDetails] = useState(false);
  const [conexaoDetailsOnline, setConexaoDetailsOnline] = useState(false);

  async function fetchServiceDetails() {
    if (details !== null) return; // já carregou, não busca de novo
    setLoadingDetails(true);
    try {
      const response = await api.post("/interno/find/serviceClienteDetails", {
        idClienteServico: id,
      });
      setDetails(response?.data || null);
    } catch (error) {
      console.error("Erro ao buscar detalhes do serviço:", error);
      setDetails({});
    } finally {
      setLoadingDetails(false);
    }
  }

  async function refreshServiceDetails() {
    setRefreshing(true);
    try {
      const response = await api.post("/interno/find/serviceClienteDetails", {
        idClienteServico: id,
      });
      setDetails(response?.data || null);
    } catch (error) {
      console.error("Erro ao atualizar detalhes do serviço:", error);
    } finally {
      setRefreshing(false);
    }
  }

  function handleExpandChange(_, isExpanded) {
    setExpanded(isExpanded);
    if (isExpanded) fetchServiceDetails();
  }

  const waitingReturn = [
    "Aguardando Instalação",
    "Aguardando Assinatura de Contrato",
    "Aguardando Configuração",
    "Aguardando Liberação de TI",
    "Aguardando Migração",
    "Aguardando Viabilidade",
    "Análise de Pendências Cadastrais",
    "Em análise cadastral",
    "Aguardando Instalação (Pré-Pago)",
  ];
  const enabledService = ["Serviço Habilitado", "Agendado para Instalação"];
  function formatarMoedaBR(input) {
    if (input == null || input === "") return "R$ 0,00";

    if (typeof input === "number") {
      input = Math?.round(input * 100)?.toString();
    }

    let digits = input?.toString()?.replace(/\D/g, "");

    while (digits?.length < 3) digits = "0" + digits;

    const cents = digits?.slice(-2);
    let integerPart = digits?.slice(0, -2);

    integerPart = integerPart?.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return `R$ ${integerPart},${cents}`;
  }
  const statusContratoCalc = (dataFimContrato) => {
    const dataFim = dayjs(dataFimContrato, "DD/MM/YYYY");
    const dataAtual = dayjs();

    return dataAtual.isAfter(dataFim) ? "Expirado" : "Em vigência";
  };

  const calcStatusRadius = (radius) => {
    if (!radius) return { isOnline: false, label: "Sem dados" };
    const temTermino = !!radius.dataTerminoSessao;
    const statusOffline = radius.status?.toLowerCase() === "offline";
    const isOnline = !temTermino && !statusOffline;
    return { isOnline, temTermino };
  };

  // Formata a duração desde dataInicioSessao até agora (ou até dataTerminoSessao se offline)
  const calcTempoSessao = (radius) => {
    if (!radius?.dataInicioSessao) return null;
    const inicio = dayjs(radius.dataInicioSessao);
    const fim = radius.dataTerminoSessao
      ? dayjs(radius.dataTerminoSessao)
      : dayjs();
    const diffSec = fim.diff(inicio, "second");
    if (diffSec < 0) return null;
    const dias = Math.floor(diffSec / 86400);
    const horas = Math.floor((diffSec % 86400) / 3600);
    const minutos = Math.floor((diffSec % 3600) / 60);
    const partes = [];
    if (dias > 0) partes.push(`${dias}d`);
    if (horas > 0 || dias > 0) partes.push(`${horas}h`);
    partes.push(`${minutos}m`);
    return partes.join(" ");
  };

  function SenhaVisivel({ senha }) {
    const [show, setShow] = useState(false);

    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Tooltip title={show && "Clique para copiar"}>
          <Typography
            sx={{ fontSize: 16, cursor: show ? "pointer" : "default" }}
            onClick={() => show && CopyTexto({ campo: senha })}
          >
            {show ? senha : "••••••••"}
          </Typography>
        </Tooltip>
        <IconButton
          size="small"
          sx={{ width: 24, height: 24, color: theme.palette.secondary.medium }}
          onClick={() => setShow((prev) => !prev)}
          aria-label="Mostrar/ocultar senha"
        >
          {show ? (
            <VisibilityOff sx={{ fontSize: 16 }} />
          ) : (
            <Visibility sx={{ fontSize: 16 }} />
          )}
        </IconButton>
      </Box>
    );
  }
  async function CopyTexto({ campo }) {
    try {
      await navigator.clipboard.writeText(campo);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = campo;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Falha ao copiar texto: ", err);
      }
      document.body.removeChild(textArea);
    }
    setSnackbar({
      children: "Campo copiado!",
      severity: "info",
    });
  }
  const handleOpenNewTicket = () => {
    setOpenNewTicket(true);
  };
  const handleCloseNewTicket = () => {
    setOpenNewTicket(false);
    setSelectedService(null);
  };

  return (
    <>
      <Accordion
        variant="outlined"
        elevation={0}
        expanded={expanded}
        onChange={handleExpandChange}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={styles.accordionSummary}
        >
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={8}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Tooltip title={`${id} - ${nome}`}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={styles.summaryTextOverflow}
                  >
                    {id} - {nome}
                  </Typography>
                </Tooltip>
                {ownerNome && <GrupoChip label={ownerNome} variant="owner" />}
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              sx={{
                ...styles.accordionTextStatus,
                justifyContent: "space-between",
                pr: 2,
              }}
            >
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Box
                  sx={{
                    ...styles.statusDot,
                    ...(waitingReturn.includes(status)
                      ? {
                          bgcolor: theme.palette.colors.orange.light,
                          animation: "pulse 1.5s infinite",
                          boxShadow: `0 0 10px ${theme.palette.colors.orange.light}`,
                        }
                      : enabledService.includes(status)
                        ? {
                            bgcolor: theme.palette.colors.green.light,
                          }
                        : {
                            bgcolor: theme.palette.colors.red.light,
                          }),
                  }}
                />

                <Tooltip title={status}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={styles.summaryTextOverflow}
                  >
                    {status}
                  </Typography>
                </Tooltip>
              </Box>
              <Button
                startIcon={<AddOutlined fontSize="small" />}
                variant="contained"
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  handleOpenNewTicket();
                  setSelectedService(id);
                }}
              >
                Novo ticket
              </Button>
            </Grid>
            {referencia && (
              <Grid item xs={12} sx={styles.accordionTextStatus}>
                <Typography
                  variant="body2"
                  fontWeight={600}
                  color="text.secondary"
                >
                  Referência:
                </Typography>
                <Tooltip title={referencia}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={styles.summaryTextOverflow}
                  >
                    {referencia}
                  </Typography>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        </AccordionSummary>
        <Divider />
        <AccordionDetails>
          <Grid container spacing={2} alignItems={"flex-start"}>
            {/*COLUNA 1 */}
            <Grid item xs={12} sm={8}>
              <Grid container spacing={0.2}>
                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <MonetizationOnOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Valor de Serviço:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() => CopyTexto({ campo: valor })}
                      >
                        {formatarMoedaBR(valor)}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <BusinessOutlined sx={styles.icons} />
                    <Typography sx={styles.boxEnderecoTitle}>
                      Endereço de Instalação:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.boxEnderecoContent}
                        onClick={() => CopyTexto({ campo: enderecoInstalacao })}
                      >
                        {enderecoInstalacao}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <CalendarMonthOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Data de Habilitação:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() =>
                          CopyTexto({
                            campo: dayjs(
                              dataHabilitacao,
                              "YYYY-MM-DD HH:mm:ss",
                            ).format("DD/MM/YYYY HH:mm"),
                          })
                        }
                      >
                        {dataHabilitacao &&
                          dayjs(dataHabilitacao, "YYYY-MM-DD HH:mm:ss").format(
                            "DD/MM/YYYY HH:mm",
                          )}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <CalendarMonthOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Data de Cadastro:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() => CopyTexto({ campo: dataCasdastro })}
                      >
                        {dataCasdastro}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <CorporateFareOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Tecnologia do serviço:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() => CopyTexto({ campo: tecnologiaUsada })}
                      >
                        {tecnologiaUsada}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <MonetizationOnOutlinedIcon sx={styles.icons} />

                    <Typography sx={styles.typhographyTitle}>
                      Forma de cobrança:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() => CopyTexto({ campo: formaCobranca })}
                      >
                        {formaCobranca}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <PersonOutlineOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Login de Autenticação:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() => CopyTexto({ campo: login })}
                      >
                        {login}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <HttpsOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Senha de Autenticação:
                    </Typography>
                    {senha && <SenhaVisivel senha={senha} />}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{ ...styles.boxCampos, my: 2, alignItems: "center" }}
                  >
                    {loadingDetails ? (
                      <Skeleton width={260} height={28} />
                    ) : (
                      (() => {
                        const radius = details?.status_conexao_radius;

                        const semDados =
                          !radius ||
                          (!radius.ipv4 &&
                            !radius.ipNas &&
                            !radius.dataInicioSessao &&
                            !radius.status);

                        if (semDados) {
                          return (
                            <>
                              <Chip
                                size="small"
                                icon={
                                  <WifiOffIcon
                                    style={{
                                      fontSize: 14,
                                      color: theme.palette.text.disabled,
                                    }}
                                  />
                                }
                                label="Sem dados"
                                sx={{
                                  border: "0.6px solid",
                                  fontWeight: 600,
                                  fontSize: 12,
                                  color: theme.palette.text.disabled,
                                  bgcolor: theme.palette.action.hover,
                                  borderColor: theme.palette.divider,
                                }}
                              />
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  mb: 0.5,
                                }}
                              >
                                <Tooltip title="Atualizar dados">
                                  <span>
                                    <IconButton
                                      size="small"
                                      onClick={refreshServiceDetails}
                                      disabled={refreshing || loadingDetails}
                                      sx={{
                                        color: theme.palette.primary.main,
                                        transition: "transform 0.4s ease",
                                        animation: refreshing
                                          ? "spin 0.8s linear infinite"
                                          : "none",
                                        "@keyframes spin": {
                                          from: { transform: "rotate(0deg)" },
                                          to: { transform: "rotate(360deg)" },
                                        },
                                      }}
                                    >
                                      <Refresh fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </Box>
                            </>
                          );
                        }

                        const { isOnline } = calcStatusRadius(radius);
                        const tempoSessao = calcTempoSessao(radius);
                        const ipv4 = radius?.ipv4 || "-";
                        const ipNas = radius?.ipNas || "-";
                        const dataInicio = radius?.dataInicioSessao
                          ? dayjs(radius.dataInicioSessao).format(
                              "DD/MM/YYYY HH:mm",
                            )
                          : "-";

                        const labelChip = isOnline
                          ? `Online há ${tempoSessao ?? "-"} · ${ipv4} · (${ipNas})`
                          : `Offline · Conectado em ${dataInicio} · ${ipv4}`;

                        const chipColor = isOnline
                          ? theme.palette.chip.colorText["success"]
                          : theme.palette.chip.colorText["critical"];

                        return (
                          <>
                            <Tooltip title="Clique para ver detalhes da conexão">
                              <Chip
                                size="small"
                                icon={
                                  isOnline ? (
                                    <WifiIcon
                                      style={{ fontSize: 14, color: chipColor }}
                                    />
                                  ) : (
                                    <WifiOffIcon
                                      style={{ fontSize: 14, color: chipColor }}
                                    />
                                  )
                                }
                                label={labelChip}
                                onClick={() => {
                                  setConexaoDetailsOnline(isOnline);
                                  setOpenConexaoDetails(true);
                                }}
                                sx={{
                                  border: "0.6px solid",
                                  fontWeight: 600,
                                  fontSize: 12,
                                  cursor: "pointer",
                                  color: chipColor,
                                  bgcolor: isOnline
                                    ? theme.palette.chip.background["success"]
                                    : theme.palette.chip.background["critical"],
                                }}
                              />
                            </Tooltip>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                mb: 0.5,
                              }}
                            >
                              <Tooltip title="Atualizar dados">
                                <span>
                                  <IconButton
                                    size="small"
                                    onClick={refreshServiceDetails}
                                    disabled={refreshing || loadingDetails}
                                    sx={{
                                      color: theme.palette.primary.main,
                                      transition: "transform 0.4s ease",
                                      animation: refreshing
                                        ? "spin 0.8s linear infinite"
                                        : "none",
                                      "@keyframes spin": {
                                        from: { transform: "rotate(0deg)" },
                                        to: { transform: "rotate(360deg)" },
                                      },
                                    }}
                                  >
                                    <Refresh fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </Box>
                          </>
                        );
                      })()
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            {/*COLUNA 2 */}
            <Grid item xs={12} sm={4}>
              <Grid container spacing={0.2} alignItems={"flex-start"}>
                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <CalendarMonthOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Vencimento:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() => CopyTexto({ campo: dataVencimento })}
                      >
                        {dataVencimento}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <RouterOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Equipamento de Roteamento:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() =>
                          CopyTexto({
                            campo: `${equipamentoRoteamento} - ${equipamentoRoteamentoIp}`,
                          })
                        }
                      >
                        {equipamentoRoteamento} - {equipamentoRoteamentoIp}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <CastConnectedOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Interface de Conexão:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() =>
                          CopyTexto({
                            campo: `${interfaceTipo} - ${interfaceNome}`,
                          })
                        }
                      >
                        {interfaceTipo} - {interfaceNome}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <SupportAgentOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Porta de atendimento:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() => CopyTexto({ campo: portaAtendimento })}
                      >
                        {portaAtendimento}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <CalendarMonthOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Data Início Contrato:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() => CopyTexto({ campo: dataInicioContrato })}
                      >
                        {dataInicioContrato}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <CalendarMonthOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Data Fim Contrato:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() => CopyTexto({ campo: dataFimContrato })}
                      >
                        {dataFimContrato}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    <RequestPageOutlinedIcon sx={styles.icons} />
                    <Typography sx={styles.typhographyTitle}>
                      Tipo de Cobrança:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Typography
                        sx={styles.typographyLabel}
                        onClick={() =>
                          CopyTexto({
                            campo: `${tipoPagamento} - ${tipoCobranca}`,
                          })
                        }
                      >
                        {`${tipoPagamento} - ${tipoCobranca}`}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={styles.boxCampos}>
                    {statusContratoCalc(dataFimContrato) === "Expirado" ? (
                      <CancelOutlinedIcon sx={styles.icons} />
                    ) : (
                      <CheckCircleOutlineOutlinedIcon sx={styles.icons} />
                    )}
                    <Typography sx={styles.typhographyTitle}>
                      Status do Contrato:
                    </Typography>
                    <Tooltip title="Clique para copiar">
                      <Chip
                        size="small"
                        label={statusContratoCalc(dataFimContrato)}
                        onClick={() =>
                          CopyTexto({
                            campo: statusContratoCalc(dataFimContrato),
                          })
                        }
                        sx={styles.contratoChip(
                          statusContratoCalc(dataFimContrato) === "Expirado",
                        )}
                      />
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Box>
            {grupos?.map((grupo) => (
              <Tooltip title="Clique para copiar" key={grupo.id}>
                <Chip
                  size="small"
                  label={grupo.descricao}
                  onClick={() => CopyTexto({ campo: grupo.descricao })}
                  sx={styles.chipGroup}
                />
              </Tooltip>
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>
      <ModalNewTicket
        open={openNewTicket}
        handleClose={handleCloseNewTicket}
        /*  refrashTIckets={refrashTickets} */
        clienteErpId={clienteInfo?.clienteErpId}
        serviceId={selectedService}
      />
      <ModalConexaoDetails
        open={openConexaoDetails}
        handleClose={() => setOpenConexaoDetails(false)}
        serviceId={id}
        isOnline={conexaoDetailsOnline}
        setSnackbar={setSnackbar}
      />
    </>
  );
}
